export { default } from "-!./Sitemap.ts?vue&type=script&lang=ts&external"; export * from "-!./Sitemap.ts?vue&type=script&lang=ts&external"